/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable eqeqeq */
/* eslint-disable consistent-return */
/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-console */
import { motion } from 'framer-motion';
import React, { useState, useEffect, useContext } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { sideBarMenu } from '../../../constants/index';
import HeaderContext from '../../Context/HeaderContext';

function Sidebar() {
    const location = useLocation();
    const [activeID, setactiveID] = useState(1);
    const [submenu, setsubmenu] = useState(false);
    const [subactive, setsubactive] = useState('');
    const [hooverId, sethooverId] = useState('');
    const [misReportSubMenu, setMisReportSubMenu] = useState(true);
    const [resourceSubmenu, setResourceSubmenu] = useState(true);
    const [userSideBarMenu, setUserSideBarMenu] = useState([]);
    const handleClick = (id) => {
        if (id === 16) {
            setResourceSubmenu(!resourceSubmenu);
        }
        if (id === 10) {
            setMisReportSubMenu(!misReportSubMenu);
        }
        setactiveID(id);
    };
    const {
        collapsed, setcollapsed, hasUnsavedChanges, requestNavigation,
    } = useContext(HeaderContext);
    const handleNavClickCapture = (e) => {
        const anchor = e.target.closest('a');
        if (hasUnsavedChanges && anchor) {
            e.preventDefault();
            e.stopPropagation();
            requestNavigation(anchor.getAttribute('href'));
        }
    };
    useEffect(() => {
        let userSideBarMenu1 = [];
        if (localStorage.getItem('user')) {
            const currentUserPrevilages = JSON.parse(localStorage.getItem('user'))?.profile?.access_privilages || [];
            userSideBarMenu1 = sideBarMenu.filter((el) => !el.previlage || currentUserPrevilages.some((f) => f === el.previlage));
            setUserSideBarMenu(userSideBarMenu1);
        }
        userSideBarMenu1.forEach((val) => {
            if (`/^${location.pathname}/`.match(val.url)) {
                setactiveID(val.id);
                return;
            }
            if (val.url === location.pathname.split('/')) {
                setactiveID(val.id);
                return;
            }
            if (val.url === '') {
                setactiveID('8');
            }
            if (val.id === 10) {
                setMisReportSubMenu(!misReportSubMenu);
            }
            if (val.id === 16) {
                setResourceSubmenu(!resourceSubmenu);
            }
        });
    }, []);
    const variants = {
        open: { opacity: 1, x: 4 },
        closed: { opacity: 0, x: 1 },
        exit: { opacity: 0, x: 1 },
        initial: { opacity: 1, x: 1 },
    };

    return (

        <div
            className={`${collapsed ? 'min-w-[6%] max-w-[6%] collapsed-sidebar custom-scrollbar' : 'min-w-[26%] max-w-[26%]'} bg-[#FFFFFF] px-3 pt-5 pb-[150px] overflow-auto border-r border-[#EBEBEB] fixed sidebar h-[100vh]`}
            onClickCapture={handleNavClickCapture}
        >
            <ul>

                {userSideBarMenu.map((menuItem) => (
                    <NavLink
                        // role={menuItem.name === 'MIS Reports' ? 'button' : ''}
                        to={(menuItem.name === 'MIS Reports' || menuItem.name === 'Resource') ? '#' : menuItem.url}
                        className={`bg-[#${menuItem.id == activeID ? 'F2F2F3' : ''}] flex hover-switch hover:bg-[#F2F2F3] hover:rounded-lg`}
                        onMouseEnter={() => sethooverId(menuItem.id)}
                        onMouseOut={() => sethooverId('')}
                        style={{ flexDirection: 'column' }}

                    >
                        <li
                            className={`bg-[#${menuItem.id == activeID ? 'F2F2F3' : ''}] rounded-lg h-[42px] pl-5 flex items-start cursor-pointer relative hover:bg-[#F2F2F3] hover:rounded-lg pt-2.5`}
                            key={menuItem.name}
                            onClick={() => handleClick(menuItem.id)}
                            style={{ flexDirection: 'column' }}
                        >
                            <>
                                {activeID === menuItem.id ? <img src={menuItem.active} alt="icon" />
                                    : (
                                        <motion.img
                                            animate={{ opacity: 1 }}
                                            initial={{ opacity: 0.5 }}
                                            src={menuItem.inactive}
                                            alt="icon"
                                        />
                                    )}

                            </>
                            <>
                                {hooverId == menuItem.id && (
                                    <motion.img
                                        animate={{ opacity: 1 }}
                                        initial={{ opacity: 0.5 }}
                                        transition={{
                                            delay: collapsed ? '1' : '0.5',
                                            x: { duration: 1 },
                                            default: { ease: 'linear' },
                                        }}
                                        src={menuItem.active}
                                        alt="icon"
                                    />
                                )}

                            </>

                            <>
                                {!collapsed
                            && (
                                <motion.p
                                    animate={!collapsed ? 'open' : 'closed'}
                                    variants={variants}
                                    className={`text-base font-normal text-[#${activeID === menuItem.id ? '090406' : '808285'}] pl-7 hover:text-[#090406]`}
                                >
                                    {menuItem.name}
                                </motion.p>
                            )}

                            </>
                        </li>

                        <ul className="bg-none">
                            {(menuItem.name === 'MIS Reports' && misReportSubMenu && menuItem.tabs)
                        && menuItem.tabs.map((ele) => (
                            <div className="pb-[16px]">
                                <li className="h-[20px] ml-[15px] pl-5 pt-2 flex-col flex items-start cursor-pointer relative">
                                    <Link to={`${ele.url}`} className="flex items-start flex-col hover-switch2">
                                        <img src="/images/document-active.svg" alt="icon" className="-mt-3" />
                                        <img src="/images/document.svg" alt="icon" className="-mt-3" />

                                        <p className="text-base font-normal pb-2 -mt-2 pl-5 text-[#808285]  hover:text-[#090406]  ">{ele.name}</p>
                                    </Link>
                                </li>
                            </div>
                        ))}

                        </ul>
                        <ul className="pl-3">
                            {(menuItem.name === 'Resource' && resourceSubmenu && menuItem.subtabs)
                            && menuItem.subtabs.map((subtab) => (
                                <div className="pb-[18px]">
                                    <li className="h-[20px] ml-[15px] pl-6  flex items-center cursor-pointer relative border-l-2 border-[#ED1C24]">
                                        <a href="" className="flex items-center hover-switch2">
                                            <img src="/images/package-active.svg" alt="icon" className="-mt-3" />
                                            <img src="/images/package-active.svg" alt="icon" className="-mt-3" />
                                            <Link to={`${subtab.url}`}>
                                                <p className="text-base font-normal pl-7 text-[#090406]">{subtab.name}</p>
                                            </Link>
                                        </a>
                                    </li>
                                </div>

                            ))}
                        </ul>

                    </NavLink>
                ))}
            </ul>
            <hr />

        </div>
    );
}
export default Sidebar;
